import React, { useRef } from "react";

const FileUploader = ({ setFile, placeholder}) => {

    const inputRef = useRef();

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    return (
        <>
            <input
                ref={inputRef}
                id="fileInput"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
            />
            <label className="fileLabel" htmlFor="fileInput">
                <input
                    type="text"
                    placeholder={placeholder}
                    readOnly
                    onClick={() => inputRef.current.click()}
                    className="form-input"
                />
            </label>
        </>
    );
};

export default FileUploader;